<template>
  <div class="vnc-modal-root">
    <!-- 两种模式都有蒙版 -->
    <div class="vnc-modal-scrim" @click="close"></div>
    <!-- 弹窗主体（全屏查看和接管电脑样式相同，只差蒙版） -->
    <div class="vnc-modal-shell">
      <div class="vnc-modal-bar">
        <span class="vnc-modal-dot" :class="'online'"></span>
        <span class="vnc-modal-title">{{ vncModal.agentName }}</span>
        <span class="vnc-modal-tag">{{ vncModal.takeover ? '接管模式' : '全屏查看' }}</span>
        <button class="vnc-modal-close" type="button" @click="close">✕</button>
      </div>
      <div class="vnc-modal-body">
        <iframe :src="vncModal.url" class="vnc-modal-iframe" frameborder="0" allow="fullscreen"></iframe>
        <!-- 全屏查看：透明遮罩盖住 iframe，阻止所有鼠标交互 -->
        <div v-if="!vncModal.takeover" class="vnc-modal-view-only"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'VncModal',
  computed: {
    ...mapState(['vncModal'])
  },
  mounted() {
    // 直接挂到 document.body，完全脱离 Vue 组件树的层叠上下文
    document.body.appendChild(this.$el)
    document.addEventListener('keydown', this.onKeydown)
  },
  beforeDestroy() {
    if (this.$el && this.$el.parentNode) {
      this.$el.parentNode.removeChild(this.$el)
    }
    document.removeEventListener('keydown', this.onKeydown)
  },
  methods: {
    close() {
      this.$store.commit('SET_VNC_MODAL', null)
    },
    onKeydown(e) {
      if (e.key === 'Escape') this.close()
    }
  }
}
</script>

<style>
.vnc-modal-root {
  position: fixed;
  top: 0; left: 0; right: 0; bottom: 0;
  z-index: 99999;
  pointer-events: none;
}

.vnc-modal-scrim {
  position: fixed;
  top: 0; left: 0; right: 0; bottom: 0;
  background: rgba(8, 12, 22, 0.78);
  backdrop-filter: blur(6px);
  pointer-events: auto;
}

.vnc-modal-shell {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100vw;
  height: 100vh;
  border-radius: 0;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  background: #0d1117;
  box-shadow: 0 40px 100px rgba(0, 0, 0, 0.7);
  pointer-events: auto;
}

.vnc-modal-bar {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 16px;
  background: #161c28;
  flex-shrink: 0;
}

.vnc-modal-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  flex-shrink: 0;
}
.vnc-modal-dot.online { background: #22c55e; }
.vnc-modal-dot.idle   { background: #94a3b8; }

.vnc-modal-title {
  flex: 1;
  font-size: 13px;
  font-weight: 700;
  color: #e0e8f5;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.vnc-modal-tag {
  font-size: 11px;
  font-weight: 600;
  padding: 2px 8px;
  border-radius: 6px;
  background: rgba(91, 141, 239, 0.18);
  color: #7eb3f5;
  flex-shrink: 0;
}

.vnc-modal-close {
  width: 28px;
  height: 28px;
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.07);
  border: none;
  color: #94a3b8;
  font-size: 13px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.vnc-modal-close:hover {
  background: rgba(255, 80, 80, 0.2);
  color: #f87171;
}

.vnc-modal-body {
  flex: 1;
  min-height: 0;
  position: relative;
}

.vnc-modal-iframe {
  width: 100%;
  height: 100%;
  border: none;
  display: block;
}

/* 全屏查看专用：透明遮罩，阻止鼠标操作 VNC */
.vnc-modal-view-only {
  position: absolute;
  inset: 0;
  z-index: 10;
  cursor: not-allowed;
}
</style>
